// TEAMS Website - Project Card Component
// Specialized card for project displays with overlay

import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../styles/main.scss';

const ProjectCard = ({
  children,
  image,
  title,
  subtitle,
  description,
  tags = [],
  link,
  linkText,
  fontFamily,
  onClick,
  className = '',
  ...props
}) => {
  const { t } = useTranslation();
  // Base classes
  const baseClasses = 'card';
  const variantClass = 'card--project';
  
  // Combine classes
  const cardClasses = [
    baseClasses,
    variantClass,
    link || onClick ? 'card--clickable' : '',
    className
  ].filter(Boolean).join(' ');

  // Card content
  const cardContent = (
    <>
      {/* Image */}
      {image && (
        <div className="card__image-container">
          <img
            src={image}
            alt={title || ''}
            className="card__image"
            loading="lazy"
          />
        </div>
      )}

      {/* Content */}
      <div className="card__content">
        {title && (
          <h3 
            className="card__title" 
            style={{ fontFamily: fontFamily || 'var(--font-family-serif)' }}
          >
            {title}
          </h3>
        )}
        
        {subtitle && (
          <p className="card__subtitle">{subtitle}</p>
        )}
        
        {description && (
          <p className="card__description">{description}</p>
        )}

        {/* Tags */}
        {tags.length > 0 && (
          <div className="card__tags">
            {tags.map((tag, index) => (
              <span key={index} className="card__tag">
                {tag}
              </span>
            ))}
          </div>
        )}

        {/* Link */}
        {linkText && (
          <div className="card__link-container">
            <span className="card__link">{linkText}</span>
          </div>
        )}
      </div>
    </>
  );

  // Render as link if link prop is provided
  if (link) {
    return (
      <a
        href={link}
        className={cardClasses}
        onClick={onClick}
        {...props}
      >
        {cardContent}
      </a>
    );
  }

  // Render as clickable div if onClick is provided
  if (onClick) {
    return (
      <div
        className={cardClasses}
        onClick={onClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
          }
        }}
        {...props}
      >
        {cardContent}
      </div>
    );
  }

  // Render as static div
  return (
    <div className={cardClasses} {...props}>
      {cardContent}
    </div>
  );
};

export default ProjectCard;
